import React, { useState } from "react";
import styled from "styled-components";
import { Avatar } from "@sonder/ui/source/styled/components/Avatar";
import { CheckboxDropdownItem } from "@sonder/ui/source/styled/fragments/CheckboxDropdownItem";
import { Label } from "@sonder/ui/source/styled/fragments/Label";
import { borders } from "@sonder/ui/source/styled/theme";
import { TagsToIcons, TomTags } from "core/queries/GetTags";
import { useManageUser } from "core/queries/ManageUser";

const StyledAvatar = styled(Avatar)`
  border: ${borders.standard};
  margin-right: 0.714rem;
`;

interface SquadManagementGroupItemProps {
  isChecked: boolean;
  squad: TomTags;
  userId: string;
}

export const SquadManagementGroupItem = ({
  isChecked: isCheckedInitial,
  squad,
  userId,
}: SquadManagementGroupItemProps) => {
  const { id: tagId, name } = squad;
  const Icon = TagsToIcons(name);

  const [isChecked, setIsChecked] = useState(isCheckedInitial);
  const [updateRoles] = useManageUser({
    variables: {
      userId,
    },
  });

  const onClick = () => {
    setIsChecked(!isChecked);

    updateRoles({
      variables: {
        userId,
        addTags: !isChecked ? [tagId] : undefined,
        removeTags: isChecked ? [tagId] : undefined,
      },
    });
  };

  return (
    <CheckboxDropdownItem checked={isChecked} onClick={onClick}>
      {Icon && <StyledAvatar name={name} svg={<Icon />} />}
      <Label>{name}</Label>
    </CheckboxDropdownItem>
  );
};
